/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AzureDevOpsListBuildLogsResponse {
    getFixupPrototypeFunction() { return AzureDevOpsListBuildLogsResponse.fixupPrototype; }

    static newInstance(model: Partial<AzureDevOpsListBuildLogsResponse>): AzureDevOpsListBuildLogsResponse {
        let obj = Object.assign(new AzureDevOpsListBuildLogsResponse(), model);
        AzureDevOpsListBuildLogsResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AzureDevOpsListBuildLogsResponse>): AzureDevOpsListBuildLogsResponse {
        if (!model) return null;
        return AzureDevOpsListBuildLogsResponse.newInstance(<AzureDevOpsListBuildLogsResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AzureDevOpsListBuildLogsResponse) {
        if (!obj) return;

        models.AzureDevOpsListBuildLogsResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AzureDevOpsListBuildLogsResponse): boolean {
        Object.setPrototypeOf(obj, AzureDevOpsListBuildLogsResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.logs) {
            for (let val of this.logs) {
                models.AzureDevOpsBuildLog.fixupPrototype(val);
            }
        }
    }

    /**
     * List of AzureDevOpsBuildLog
     */
    logs: Array<models.AzureDevOpsBuildLog>;

}
